export default "__VITE_ASSET__B5Bih4Ws__"